/** Inline validation for the New session form. Pure, so it is unit tested. */
import type { SessionStartMode } from '@orgus/protocol';

/** Why a branch name is not usable, or null. Follows `git check-ref-format --branch`. */
export function branchError(raw: string, taken: readonly string[] = []): string | null {
  const name = raw.trim();
  if (!name) return 'Enter a branch name for the new worktree.';
  if (/\s/.test(name)) return 'Branch names cannot contain spaces. Use a dash instead.';
  if (/[~^:?*[\\\x00-\x1f\x7f]/.test(name)) return 'Branch names cannot contain ~ ^ : ? * [ or a backslash.';
  if (name.startsWith('-')) return 'Branch names cannot start with a dash.';
  if (name.startsWith('/') || name.endsWith('/') || name.includes('//')) return 'Slashes separate parts of the name; none can be empty.';
  if (name.includes('..')) return 'Branch names cannot contain two dots in a row.';
  if (name.includes('@{') || name === '@') return 'Branch names cannot contain @{.';
  if (name.endsWith('.') || name.endsWith('.lock')) return 'Branch names cannot end with a dot or .lock.';
  if (name.split('/').some((part) => part.startsWith('.'))) return 'No part of a branch name can start with a dot.';
  if (taken.includes(name)) return 'A checkout on this machine already uses that branch. Pick another name.';
  return null;
}

/** `who` is the agent as it is named in a sentence: Claude, Codex. */
export function promptError(prompt: string, mode: SessionStartMode, who = 'Claude'): string | null {
  if (mode === 'headless' && !prompt.trim()) return `Describe what ${who} should do. A headless session needs a prompt to start.`;
  if (prompt.length > 20_000) return `That prompt is over 20,000 characters. Put the detail in a file and point ${who} at it.`;
  return null;
}

/** A suggested branch name from the first words of a prompt: "Fix the login race" gives "fix-the-login-race". */
export function suggestBranch(prompt: string, prefix = 'claude'): string {
  const words = prompt
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, ' ')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 5);
  return words.length ? `${prefix}/${words.join('-')}`.slice(0, 48).replace(/-+$/, '') : '';
}
